import React, { Component } from 'react';
import './setting.css'
import   SideNav from "./../../component/sidenav/sidenav.js"
import  AuthService  from "../api/authentication.js";
import  Moble from "./../../component/sidenav/moble.js"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import {
    
    Redirect
  } from 'react-router-dom'


  const Auth = new AuthService();
class  Setting extends Component {

    
    constructor(props){
        super(props)
        this.state = {
            
            noerorrpage :  true,
            isActive : false,
            photos : [],
            images: [],
            imageUrls : [],
            details:[],
            ifImage :false,
            Imgprofile:true,
            logoPro:false,
            certificat : false,
            domain: 'https://exam-end.herokuapp.com', 
            localApi:'http://localhost:4000',  
            ShowPassword:false,
            errormesage:"",
            passwordcom:"",
            erorrDiv:false
        }
    }

    componentWillReceiveProps(nextProps) {
		

      if (nextProps.user) {
     
        this.timeout()
        
      
        // this.getDashboardDatas(nextProps.user);
        
      }
    }

    componentDidMount(){
      this.props.noerorrpage(this.state.noerorrpage)
      this.setState({
        isActive:true,
        loanData:true
      })
    
        // this.props.checkUsercodition(this.checkUsers())
   
        // console.log("users  condition ===", this.checkUsers())
    }
    
        checkUsers = ()=>{
            if(!this.props.user.fullname == "" && !this.props.user.address == ""  &&  !this.props.user.about == ""
            && !this.props.user.account_no == "" 
             && !this.props.user.phone_one =="" && !this.props.user.phone_two == "" ){
                 this.setState({
                   submitIftrue : true,
                 })
               return true
           }else{
               this.setState({
                   submitIftrue : false
                 })
               return  false
           }
       }

       
selectImages = (event) => {
  event.preventDefault();
let images = []
let photos  = []
for (var i = 0; i <  event.target.files.length && i < 1 ; i++) {
    images[i] = event.target.files.item(i);
    photos[i] =  URL.createObjectURL(event.target.files.item(i))

 }
if(event.target.files.length  !== 0){
 this.setState({
   ifImage :true,
   editImage :true
 })
}else{
  this.setState({
    ifImage :false
  })
}
// console.log("iamge -------->rt", photos)

images = images.filter(image => image.name.match(/\.(jpg|jpeg|png|gif)$/))
let message = `${images.length} valid image(s) selected`
this.setState({ images, message , photos})
}


uploadImages=(event) => {
  event.preventDefault();
    this.setState({
      loanData:true,
    })
   const uploaders = this.state.images.map(image => {
        const formData = new FormData();
        //  console.log('done image---->', image );
      
          formData.append('uri', image, image.name);
          formData.append("profile_image", true);
          formData.append('user_id',  this.props.user._id);

        const options = {
            method: 'POST',
            headers: { 
                'content-type': 'multipart/form-data',
            'access-control-allow-origin': '*',
            'Authorization': Auth.getToken(), 
            },
            url:this.state.domain+"/upload-logo",
 };
   // Make an AJAX upload request using Axios
   return  axios.post(options.url, formData, options.headers)
   .then(response => {
        //  console.log("response", response.data.result)
         this.setState({
           imageUrls: [response.data.result, ...this.state.imageUrls ]
           });
         
       })
      
 });

 
   // Once all the files are uploaded 
     axios.all(uploaders).then(() => {
      //  this.forceUpdate(this.state.imageUrls)
      toast("Photo uploader !");
          // console.log('done');
          this.setState({
            loanData:false,
            ifImage:false
          })
     }).catch(err => alert(err.message));

}

upDate_data=(e)=>{
   e.preventDefault()
   this.setState({
    loanData:true,
    ifSubmit: true
   })
   const data= {
    phoneNumber:this.tel.value,
    // last_name: this.address.value,
    city: this.city.value,
    name: this.name.value,
    address: this.address.value,
 
   }
   const requestOptionsUser = {
    method: 'PUT', 
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
    body: JSON.stringify(data),
};
    console.log("data update", data,  )
   
          //    console.log("data update", requestOptions, this.props.user. _id)
             fetch(this.state.domain+"/updateSchool/"+ this.props.user._id, requestOptionsUser)
             .then(res => res.json())
             .then((res)=>{
                 if(res.status ===  true){
                    // console.log("result", res)
                    toast("Updated !");
                     this.setState({
                         loading:false,
                         loanData:false,
                         ifSubmit:false
                     })
                     
                    //  this.props.history.replace('/dashboard');
                 }else{
                     toast(" Not Updated !");
                 }
               
             }).catch( (error) => {
                 //  console.log("errro", error);
                  // console.log("error load", error )
              })
   
   
}


UpdatePassword=(e)=>{
  e.preventDefault()
  if(this.state.errormesage){
    this.setState({
      errormesage:true,
      erorrDiv:true,
      passwordcom:"Passwords  confirmation do not match"
  })
  }else{
    this.setState({
      loanData:true,
      ifSubmit: true
     })
     const data= {
    
      password:this.password.value,

     }
     const requestOptionsUser = {
         method: 'PUT', 
         headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
         body: JSON.stringify(data),
      };
      console.log("data update", data,  )
           fetch(this.state.domain+"/updateSchool/"+ this.props.user._id, requestOptionsUser)
           .then(res => res.json())
           .then((res)=>{
               if(res.status ===  true){
                 // console.log("result", res)
                 toast("Updated !");
                   this.setState({
                       loading:false,
                       loanData:false,
                       ifSubmit:false
                   })
                   
                 //  this.props.history.replace('/dashboard');
               }else{
                   toast(" Not Updated !");
               }
                 
            }).catch( (error) => {
                   //  console.log("errro", error);
                    // console.log("error load", error )
        })
  }

  
}




timeout() {
  setTimeout(function() {
 //    this.setState({ imageshow:false})
   this.setState({
      loanData:false
   })
  //   console.log("time out",this.state.showimage);
  }.bind(this), 3000);
}

ShowPassword=(e)=>{
  e.preventDefault()
  this.setState({
    ShowPassword:true
  })
}

closePassword=()=>{
  this.setState({
    ShowPassword:false
  })
}

passwordconfirChange =(event)=>{
  this.setState({value: event.target.value});
  // console.log("com", this.passwordconfir.value, "password",this.password.value)
  if(this.passwordconfir.value === this.password.value){
      // console.log("conform")
      this.setState({
          errormesage:false,
          passwordcom:"",
          erorrDiv:false
      })
  }else{
      // console.log("not correct")
      this.setState({
          errormesage:true,
          erorrDiv:true,
          passwordcom:"Passwords  confirmation do not match"
      })
      // console.log("not correct" , this.state. passwordcom)

  }
}


    logout = () =>{
        // console.log("judge love")
        this.props.logout()
      }

    render(){

        // console.log("cheking---------", this.props.isAuthenticated)
        // console.log("cheking users---------", this.props.user )
         return(
            
          <div id="dashboard-wrapper " class="columns dashboard-cousom">
              <ToastContainer />
              {this.state.loanData?
                //   <Leader/>
                    <div class="pre-loader">
                  <div class="loader"></div>
                </div> 
                      :
                      <div></div>
               }
          <div class="column"></div>
              <div class="content column is-11">
          
                  {/* <!-- Breadcrumbs --> */}
                  <nav class="breadcrumbs">
                      {/* <button onClick={this.clickeme}>click</button> */}
                      <ul>
                          <li><a href="/">Home</a></li>
                          <li>User Setting</li>
                      </ul>
                  </nav>
                  {/* <!-- /Breadcrumbs -->
          
                  <!-- Dashboard Wrapper --> */}
                    <div class="dashboard-wrapper">
                        <div className="setting-profiling-image">
                        <div class="columns">
                            <div class="column is-one-third">
                        <div className='setting-card-image-body'>
                        
                           
                        </div>
                            <ul class="list-block coustom-setting-me">
                                <li ><i class="sl sl-icon-user"> : </i> <a> {this.props.user.name} {" " }</a></li>
                                <li><i class="sl sl-icon-envelope-open"> : </i> <a>@username {this.props.user.username}</a></li>
                                <li> <i class="sl sl-icon-phone"> : </i><a>{this.props.user.phoneNumber}</a></li>
                                <li>   <i class="sl  sl-icon-globe"> : </i> <a>{'Nigeria'}</a></li>
                                <li>   <i class="sl  sl-icon-location"> : </i> <a>{this.props.user.address}</a></li>
                            </ul>
                            </div>
                            <div class="column">
                            {
                              this.state.ShowPassword?
                              <div></div>
                              :
                            <div  className='setting-input-body'>
                                <button  class="button is-primary " onClick={this.ShowPassword} style={{width:'100%'}}>
                                     Change   Password
                                </button>
                            </div>
                            }
                            {
                              this.state.ShowPassword?
                              <div className="setting-input-body">
                                  <div class="flex-card is-contact-info light-bordered card-overflow"> 
                                      <div className="setting-input-sub">
                                          <form onSubmit={this.UpdatePassword}>
                                          <div class="columns">
                                          <div class="column is-one-third">New Password</div>
                                          <div class="column">
                                              <div class="control">
                                                  <input class="input is-small" 
                                                  type="password" ref={input => this.password = input }
                                                  onChange={this.posswordChange} placeholder="Password " required
                                                   />
                                                </div>
                                              </div>
                                          </div>
      

                                          <div class="columns">
                                          <div class="column is-one-third"> Confirm Password  </div>
                                          <div class="column">
                                              <div class="control">
                                                  <input class="input is-small" 
                                                  type="password" ref={input => this.passwordconfir = input }  
                                                  onChange={this.passwordconfirChange} placeholder="Password confirmation"
                                                   required/>
                                                </div>
                                              </div>
                                          </div>

                                          <br/>
                                          { 
                                            this.state.errormesage
                                                ?    <div className="errormeage"> <span className="error-span"style={{color:"red"}} > {this.state.passwordcom} </span> </div>
                                                :   <span className="error-span"> </span>
                                           }
      
                                        <div className="info-payment-button">
                                            {
                                            ! this.state.ifSubmit ?
                                                <button  class="button is-primary is-rounded" >Submit</button>
                                            :
                                            
                                                <div className="level-item">
                                                <a className="button is-loading is-large is-light">Loading</a>
                                                </div>
                                                
                                            
    
                                            }
                                            <a  class="button  is-danger is-rounded" onClick={this.closePassword} style={{marginLeft:'10%'}}>Close</a>
                                        </div>
      
                                        
      
      
      
                                          </form>
                                      </div>
                                  </div>
                               </div> 
                              :
                              <div></div>
                            }
                            {
                              this.state.ShowPassword?
                              <div></div>
                              :
                              
                          <div className="setting-input-body">
                            <div class="flex-card is-contact-info light-bordered card-overflow"> 
                            <div className="setting-input-sub">
                             <form onSubmit={this.upDate_data}>
                                   
 
                                    
 
                           
                                     <div class="columns">
                                     <div class="column is-one-third">Name</div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                             ref={ input => this.name = input }
                                             defaultValue={this.props.user.name}
                                             placeholder="Mobile" required/>
                                           </div>
                                         </div>
                                     </div>
 
 
                                     <div class="columns">
                                     <div class="column is-one-third"> Tel</div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                               ref={ input => this.tel = input }
                                               defaultValue={this.props.user.phoneNumber}
                                             placeholder="Telephone" required/>
                                           </div>
                                         </div>
                                     </div>

                                   

                                     <div class="columns">
                                     <div class="column is-one-third"> City </div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                               ref={ input => this.city = input }
                                               defaultValue={this.props.user.city}
                                             placeholder="City" required/>
                                           </div>
                                         </div>
                                     </div>
 
 
                                   
 
                                     <div class="columns">
                                     <div class="column is-one-third">Address </div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                               ref={ input => this.address = input }
                                               defaultValue={this.props.user.address}
                                             placeholder="Address" required/>
                                           </div>
                                         </div>
                                     </div>
 
 
                                    

                                     
 
                                     <div className="info-payment-button">
                                       {
                                        ! this.state.ifSubmit ?
                                            <button  class="button is-primary is-rounded" >Submit</button>
                                        :
                                        
                                            <div className="level-item">
                                            <a className="button is-loading is-large is-light">Loading</a>
                                            </div>
                                            
                                        

                                       }
                                    
                                     </div>
                                     </form>  
                                    </div>   
                                   </div>
                                  </div> 
                                }
                                </div>
                           </div>
                       </div>
                     </div>  
                  </div>
             </div>
         )
     

    }
      
}   

export default Setting;


// WEBPACK FOOTER //
// ./src/component/setting/setting.js